module.exports = __webpack_public_path__ + "media/images/flags/32/Vietnam-a195eaf103d80a1e957a3d00d25d0dd9.png";